export function microphoneOptions(){
 return {deviceId:localStorage.getItem('malvo-audioinput')||'default',echoCancellation:true,noiseSuppression:localStorage.getItem('malvo-noise-suppression')!=='0',autoGainControl:true,channelCount:1};
}
export function createMutedSpeechGate(cooldown=20000){
 let started:number|null=null,last=-Infinity;
 return (rms:number,time:number)=>{
  if(!Number.isFinite(rms)||rms<.055){started=null;return false;}
  if(started===null)started=time;
  if(time-started<450||time-last<cooldown)return false;
  last=time;return true;
 };
}
/** Smooth SFU activity for the indicator, never changes or suppresses audio. */
export function createSpeakingIndicator(){
 const seen=new Map<string,{start:number;last:number;shown:boolean}>();
 return (inputs:{id:string;active:boolean;enabled:boolean}[],time:number)=>{
  const ids=new Set(inputs.map(p=>p.id)),visible=new Set<string>();
  for(const id of seen.keys())if(!ids.has(id))seen.delete(id);
  for(const p of inputs){
   if(!p.enabled){seen.delete(p.id);continue;}
   let state=seen.get(p.id);
   if(p.active){if(!state||time-state.last>300)state={start:time,last:time,shown:false};state.last=time;if(time-state.start>=180)state.shown=true;seen.set(p.id,state);}
   if(state?.shown&&time-state.last<=250)visible.add(p.id);
  }
  return visible;
 };
}
